import * as React from "react";
import { Moment } from "moment";
import ReactDatePicker from "react-datepicker";
import { isWorkDay } from "../../date_helpers";

interface DatePickerProps {
    startDate: Moment;
    onDateChange: (e: any) => void;
}

export function DatePicker({ startDate, onDateChange }: DatePickerProps) {
    return (
        <div className="date-picker-wrapper">
            <ReactDatePicker
                inline
                selected={startDate}
                onChange={onDateChange}
                filterDate={isWorkDay as () => any}
                todayButton={"Today"}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ts/components/calculator/datepicker.tsx